// extracted by css-extract-rspack-plugin
export default {"layer":"layer-iwsWMS"};